import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

/*
 * toaster.create({ title, description, type }) —— 呼叫方式沿用原本 Chakra 版，
 * 底下換成 MUI 的 Snackbar + Alert。一次只顯示一則，後到的排隊。
 * type：success / error / warning / info（loading 當 info 顯示）。
 */
let queue = [];
let listener = null;
let seq = 0;

const emit = () => listener && listener([...queue]);

export const toaster = {
  create({ title, description, type = "info", duration = 4000 } = {}) {
    seq += 1;
    queue.push({ id: seq, title, description, type: type === "loading" ? "info" : type, duration });
    emit();
    return seq;
  },
  dismiss(id) {
    queue = id == null ? [] : queue.filter((t) => t.id !== id);
    emit();
  },
};

export const Toaster = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    listener = setItems;
    return () => {
      listener = null;
    };
  }, []);

  const current = items[0] || null;
  const close = (_e, reason) => {
    if (reason === "clickaway") return;
    toaster.dismiss(current?.id);
  };

  return (
    <Snackbar
      key={current?.id}
      open={!!current}
      autoHideDuration={current?.duration}
      onClose={close}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      {current ? (
        <Alert onClose={close} closeText="關閉" severity={current.type} variant="filled" sx={{ minWidth: 280 }}>
          {current.title}
          {current.description ? <div style={{ opacity: 0.85 }}>{current.description}</div> : null}
        </Alert>
      ) : null}
    </Snackbar>
  );
};
